export type SupportMessagePart =
  { type: 'text'; value: string } | { type: 'link'; href: string };

const URL_CANDIDATE_PATTERN = /https?:\/\/[^\s<>"'«»“”‘’]+/gu;
const TERMINAL_SENTENCE_PUNCTUATION_PATTERN = /[.,;:!?…。、，；：！？]+$/u;

const BRACKET_PAIRS = [
  ['(', ')'],
  ['[', ']'],
  ['{', '}'],
  ['（', '）'],
  ['［', '］'],
  ['｛', '｝'],
  ['〈', '〉'],
  ['《', '》'],
  ['「', '」'],
  ['『', '』'],
  ['【', '】'],
  ['〔', '〕'],
  ['〖', '〗'],
] as const;

const occurrences = (value: string, character: string): number =>
  [...value].filter((candidate) => candidate === character).length;

const splitTerminalPunctuation = (
  candidate: string
): { href: string; trailing: string } => {
  let href = candidate;
  let trailing = '';
  const sentencePunctuation =
    href.match(TERMINAL_SENTENCE_PUNCTUATION_PATTERN)?.[0] ?? '';
  if (sentencePunctuation) {
    href = href.slice(0, -sentencePunctuation.length);
    trailing = sentencePunctuation;
  }

  let removedBracket = true;
  while (removedBracket && href.length > 0) {
    removedBracket = false;
    for (const [opening, closing] of BRACKET_PAIRS) {
      if (
        href.endsWith(closing) &&
        occurrences(href, closing) > occurrences(href, opening)
      ) {
        href = href.slice(0, -closing.length);
        trailing = `${closing}${trailing}`;
        removedBracket = true;
        break;
      }
    }
  }
  return { href, trailing };
};

export const linkifySupportMessage = (body: string): SupportMessagePart[] => {
  const parts: SupportMessagePart[] = [];
  let cursor = 0;
  for (const match of body.matchAll(URL_CANDIDATE_PATTERN)) {
    const matchIndex = match.index ?? 0;
    if (matchIndex > cursor) {
      parts.push({ type: 'text', value: body.slice(cursor, matchIndex) });
    }
    const candidate = match[0];
    const { href, trailing } = splitTerminalPunctuation(candidate);
    if (href) parts.push({ type: 'link', href });
    if (trailing) parts.push({ type: 'text', value: trailing });
    cursor = matchIndex + candidate.length;
  }
  if (cursor < body.length) {
    parts.push({ type: 'text', value: body.slice(cursor) });
  }
  return parts;
};
